import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const Chip = styled.span`
  display: inline-flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.surface};
  border-radius: 1.2rem;
  padding: ${({ theme }) => `${theme.spacing.xs} ${theme.spacing.md}`};
`;

export const ChipName = styled.span`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.darkSlate};
  font-weight: 600;
`;

export const ChipPrice = styled.span<{ $accent: string }>`
  font-size: 1.2rem;
  color: ${({ $accent }) => $accent};
  font-weight: 600;
  margin-top: 0.2rem;
`;

export const ChipNote = styled.span`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-top: 0.1rem;
`;
